'use client'

import { useAuthUser } from '@common/core/hooks/useAuthUser'

/**
 * Wrapper for Auth0 useUser hook that returns empty user for Vision local mode
 * This prevents Auth0 from making requests to /api/auth/profile in local mode
 */
export function useUser() {
  return useAuthUser()
}
